import React from "react";

export default function WorkspaceTitleHeader({
  icon: Icon,
  title,
  subtitle,
  actions,
  className = "",
  headingAs: Heading = "h1",
}) {
  return (
    <div
      className={`flex flex-col gap-3 lg:flex-row lg:items-start lg:justify-between ${className}`.trim()}
    >
      <div className="flex min-w-0 items-start gap-3">
        {Icon ? (
          <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-emerald-600">
            <Icon className="h-4 w-4 text-white" />
          </div>
        ) : null}
        <div>
          <Heading className="text-[16px] font-semibold text-slate-900">{title}</Heading>
          {subtitle ? (
            <p className="text-sm text-slate-500">{subtitle}</p>
          ) : null}
        </div>
      </div>

      {actions ? (
        <div className="flex shrink-0 flex-wrap items-center gap-2">{actions}</div>
      ) : null}
    </div>
  );
}
